import InvestmentProfileUpdateDrawer from "./InvestmentProfileUpdateDrawer"

export default InvestmentProfileUpdateDrawer
